// Shown for the moment a screen's code is downloading on first load.
export function BootScreen() {
  return (
    <div style={{ minHeight: '100dvh', display: 'grid', placeItems: 'center', background: 'var(--bg-page)' }} aria-busy="true">
      <span style={{ fontSize: 28, fontWeight: 800, letterSpacing: '-0.5px', color: 'var(--ink)' }}>guildite</span>
    </div>
  );
}
